import React, { useState } from "react";
import { toast } from "react-toastify";

export default function ApplicationFinalStep() {
  const [inputLines, setInputLines] = useState([""]);

  const handleInputChange = (index, value) => {
    const updatedLines = [...inputLines];
    updatedLines[index] = value;
    setInputLines(updatedLines);
  };

  const handleRemoveInput = (index) => {
    const updatedLines = inputLines.filter((_, i) => i !== index);
    setInputLines(updatedLines);
  };

  const handleAddInput = () => {
    setInputLines([...inputLines, ""]);
  };

  const handleSubmit = async (event) => {
    const token = localStorage.getItem("EXPERT_AUTH_TOKEN");
    event.preventDefault();
    try {
      const response = await fetch(
        "http://localhost:5000/api/expert/expertise",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            topicHeading: document.getElementById("heading").value,
            areaCovered: inputLines,
            language: document.getElementById("language").value,
          }),
        }
      );

      if (response.status === 200) {
        toast.success("Form submitted successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (response.status === 400) {
        toast.error("Bad request", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Internal Server Error: ", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className=" min-h-screen flex flex-col justify-center items-center bg-gray-100">
      <h1 className="text-2xl font-semibold mb-4">
        Congratulations! Your Application Has Been Approved
      </h1>
      <p className="text-gray-600 mb-6 ">
        Let's build your profile - (This will take a maximum of 15 minutes)
      </p>

      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <form>
          <div className="mb-4">
            <label
              htmlFor="heading"
              className="block text-base font-medium text-gray-700"
            >
              Heading
            </label>
            <p className="text-sm text-gray-500">
              (This will be a one line statement about your profile to users
              containing information related to category, topic and offering)
            </p>
            <input
              type="text"
              id="heading"
              name="heading"
              className="mt-1 p-2 w-full border rounded-md  focus:outline-cyan-400"
              placeholder="Enter your heading"
            />
          </div>

          <div>
            <h2 className="block text-base font-medium text-gray-700 mb-1">
              Topic Area Covered
            </h2>
            <p className="text-sm text-gray-500">
              (This is how users will be able to know who you are offering in
              your selected topics)
            </p>
            {inputLines.map((line, index) => (
              <div key={index} className="flex flex-col mb-2">
                <input
                  value={line}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  className="flex-grow p-2 border rounded-md focus:outline-cyan-400"
                  placeholder={`Enter line ${index + 1}`}
                />
                {index > 0 && (
                  <button
                    type="button"
                    className="text-start text-red-600 hover:text-red-800 ml-2 mt-1"
                    onClick={() => handleRemoveInput(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              className="text-blue-600 hover:text-blue-400 mt-2"
              onClick={handleAddInput}
            >
              + Add more
            </button>
          </div>

          <div className="mb-4">
            <label
              htmlFor="language"
              className="block text-base font-medium text-gray-700 "
            >
              Language
            </label>
            <p className="text-base text-gray-500">
              (Your best language to interact with users, eg : Hindi, English)
            </p>
            <input
              type="text"
              id="language"
              name="language"
              className="mt-1 p-2 w-full border rounded-md  focus:outline-cyan-400"
              placeholder="Enter the language"
            />
          </div>

          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 active:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-400 text-white px-4 py-2 rounded"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
